import { Image } from 'antd';

import { ColorModel, MaterialModel } from '@common/models';
import { COMING_SOON_IMAGE, setDefaultSrc } from '@common/utils';
import ImageUtils from '@core/utils/ImageUtils';

import './selected-color.scss';

export const getImageSource = (selectedColor: ColorModel, defaultUrl: string): string => {
    return selectedColor.beautyShotImageUrl ? selectedColor.beautyShotImageUrl : defaultUrl;
};

interface SelectedColorProps {
    countertopAreaQty?: number;
    material?: MaterialModel;
    selectedColor?: ColorModel;
}

export const SelectedColor = ({ countertopAreaQty, material, selectedColor }: SelectedColorProps): JSX.Element => {
    return (
        <div className="SelectedColor">
            {selectedColor ? (
                <div className="SelectedColor__image-container">
                    <Image
                        className="SelectedColor__image"
                        preview={false}
                        src={ImageUtils.imgUrl(getImageSource(selectedColor, COMING_SOON_IMAGE), 300)}
                        onError={setDefaultSrc}
                    />

                    {material && countertopAreaQty ? (
                        <SelectedMaterial selectedColor={selectedColor} material={material} />
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};

type SelectedMaterialProps = Omit<SelectedColorProps, 'countertopAreaQty'>;

const SelectedMaterial = ({ selectedColor, material }: SelectedMaterialProps): JSX.Element | null => {
    return selectedColor && material ? (
        <div className="SelectedMaterial">{material.description + ': ' + selectedColor.name}</div>
    ) : null;
};
